import React from "react";
import { printCashierReceipt, printOrderInvoice } from "../../data/orders";

const formatPrice = (value) => `${Number(value || 0).toFixed(2)} €`;

const OrderDetailsView = ({ order, onReturnItem, onClose }) => {
  if (!order) return null;

  return (
    <div className="h-100 d-flex flex-column text-white" style={{ backgroundColor: "#4b5563" }}>
      <div className="p-3 d-flex justify-content-between align-items-center border-bottom" style={{ borderColor: "#6b7280" }}>
        <h5 className="mb-0 fw-bold">
          {order.isReturn ? "Avoir" : "Commande"} {order.id}
          {order.isReturn && <span className="badge bg-danger ms-2" style={{ fontSize: "0.7rem" }}>RETOUR</span>}
        </h5>
        <span className="text-info">{order.items.length} ARTICLE{order.items.length > 1 ? "S" : ""}</span>
      </div>

      <div className="flex-grow-1 overflow-auto p-3">
        {order.items.map((item, idx) => (
          <div key={idx} className="bg-light text-dark p-2 mb-2 rounded d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
              <div style={{ maxWidth: "220px" }}>
                <div className="text-info fw-bold text-truncate d-flex align-items-center gap-1" style={{ fontSize: "0.9rem" }}>
                  {item.name || item.title || "Produit"}
                  {item.isReturn && <span className="badge bg-danger" style={{ fontSize: "0.6rem" }}>RETOUR</span>}
                </div>
                {item.returnRef && <div className="text-muted" style={{ fontSize: "0.7rem" }}>Réf: {item.returnRef}</div>}
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <span className="fw-bold">{item.quantity}</span>
              <span className={`fw-bold ${Number(item.lineTotal) < 0 ? "text-danger" : ""}`}>{formatPrice(item.lineTotal)}</span>
              {!item.isReturn && (
                <button
                  className="btn btn-sm text-white py-1 px-2"
                  style={{ backgroundColor: "#f97316" }}
                  onClick={() => onReturnItem && onReturnItem(item)}
                  title="Retour produit"
                >
                  <i className="bi bi-arrow-return-left"></i>
                </button>
              )}
            </div>
          </div>
        ))}

        <div className="mt-4 p-3 bg-dark bg-opacity-25 rounded border" style={{ borderColor: "#6b7280" }}>
          <div className="d-flex justify-content-between align-items-start mb-3">
            <div>
              <div className="fw-bold mb-1">ALMOUNÉ BOUTIQUE</div>
              <div className="small">ALMOUNÉ</div>
              <div className="small text-uppercase">
                {order.isReturn ? "RETOUR" : "EN MAGASIN"} {new Date(order.date).toLocaleString()}
              </div>
              {order.refundedFrom && <div className="small text-warning mt-1">Commande d'origine: {order.refundedFrom}</div>}
            </div>
            <div className="text-end">
              <div className="d-flex justify-content-end gap-3 mb-1">
                <span className="text-info">Total</span>
                <span className={`fw-bold fs-5 ${Number(order.total) < 0 ? "text-danger" : "text-info"}`}>{formatPrice(order.total)}</span>
              </div>
              <div className="d-flex justify-content-end gap-3 text-white">
                <span>TVA</span>
                <span className="fw-bold">{formatPrice(order.totalTVA || order.total * 0.055)}</span>
              </div>
            </div>
          </div>

          <div className="d-flex gap-4">
            <div className="flex-grow-1">
              {order.payments && order.payments.map((p, i) => (
                <div key={i} className="d-flex justify-content-between align-items-center mb-1 small text-uppercase">
                  <span style={{ width: "80px" }}>{p.method}</span>
                  <span>{formatPrice(p.amount)}</span>
                </div>
              ))}
              <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top border-secondary small fw-bold text-uppercase">
                <span>Total Payé</span>
                <span>{formatPrice((order.payments || []).reduce((s, p) => s + p.amount, 0))}</span>
              </div>
            </div>

            <div className="d-flex flex-column gap-2" style={{ width: "200px" }}>
              <button className="btn btn-info text-white fw-bold py-1" onClick={() => printCashierReceipt(order)}>
                <i className="bi bi-printer me-1"></i> TICKET
              </button>
              <button className="btn btn-info text-white fw-bold py-1" onClick={() => printOrderInvoice(order)}>
                <i className="bi bi-file-earmark-text me-1"></i> FACTURE
              </button>
            </div>
          </div>
        </div>
        
        <div className="mt-4 text-center">
          <button className="btn btn-outline-light px-4" onClick={onClose}>Fermer</button>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsView;
